var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'uk-container': true,
    'uk-container-small': _vm.size === 'small',
    'uk-container-medium': _vm.size === 'medium'
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }